import React from "react";
import Header from "../../components/Header";
import AddUserModal from "../../components/AddUserModal";
import EditSuperAdminModal from "../../components/EditSuperAdminModal";
import ResetPasswordSuperAdminModal from "../../components/ResetPasswordSuperAdminModal";
import Firebase from "../../firebasehelper";
import "./index.css";
import { resetPassword, removeTaskerFromAuth } from "../../api/UserApi";

const user_icon = require("../../assets/media/user.png");
const remove_icon = require("../../assets/media/stop.png");

class SuperDevs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      domain: [],
      loading: false,
      developers: [],
      brand_name: "",
      brand_url: "",
      searchKey: "",
      searchStatus: "",
    };
  }
  componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    } else {
      const { role, username } = this.props.location.state;
      this.setState({ username, role, loadingBrands: true });
      Firebase.getSuperDevelopers((res) => {
        console.log("super developers", res);
        this.setState({ developers: res });
      });
    }
  }

  editBrandAdmin = (item) => () => {
    this.setState({
      selectedUser: item,
    });
  };

  onResetPassword = (password) => {
    const { selectedUser } = this.state;
    if (selectedUser) {
      resetPassword(selectedUser.uid, password).catch(() => {
        console.log("Something went wrong!");
      });
    }
  };

  addUser = (username, email, password) => {
    Firebase.addAgency(email, password)
      .then((uid) => {
        Firebase.writeAgencydata(uid, {
          uid: uid,
          username,
          email,
          approved: true,
          role: 20,
          isSuper: true,
        });
      })
      .catch((err) => {
        alert(err);
      });
  };

  removeBrandDeveloper = (item) => () => {
    const { uid } = item;
    Firebase.removeDeveloper(uid);
    removeTaskerFromAuth(uid);
  };

  render() {
    const {
      username,
      role,
      logo,
      developers,
      brand,
      brand_name,
      is_property_brand,
      selectedUser,
    } = this.state;
    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container">
          <div className="home-content">
            <div className="user-content">
              <div className="brand-admin-table-header">
                <div style={{ width: "50px" }} />
                <div className="brand-admin-row name-container">Name</div>
                <div className="brand-admin-row email-container">Email</div>
                <div className="brand-admin-row"></div>
              </div>
              {developers.map((item) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      marginBottom: "15px",
                    }}
                  >
                    <img src={user_icon} width="50" alt="icon" />
                    <div className="brand-admin-row name-container">
                      <h4 style={{ marginBottom: 0 }}>{item.username}</h4>
                      <img
                        src={remove_icon}
                        className="remove-icon"
                        alt="remove"
                        onClick={this.removeBrandDeveloper(item)}
                      />
                    </div>
                    <div className="brand-admin-row email-container">
                      {item.email}
                    </div>
                    <div className="brand-admin-row actions-container">
                      <button
                        type="button"
                        class="btn"
                        data-toggle="modal"
                        data-target="#reset_password_super_admin"
                        onClick={this.editBrandAdmin(item)}
                      >
                        Reset password
                      </button>
                    </div>
                  </div>
                );
              })}
              <button
                type="button"
                className="btn btn-success push"
                data-toggle="modal"
                data-target="#add_user"
                style={{ marginTop: 20 }}
              >
                Add new outbound API partner
              </button>
            </div>
          </div>
        </main>
        <AddUserModal
          addUser={(username, email, password) =>
            this.addUser(username, email, password)
          }
        />
        <EditSuperAdminModal
          onSave={this.onEditUser}
          initialValues={selectedUser}
        />
        <ResetPasswordSuperAdminModal
          onSave={this.onResetPassword}
          initialValues={selectedUser}
        />
      </div>
    );
  }
}
export default SuperDevs;



// WEBPACK FOOTER //
// ./src/screens/SuperDevs/index.js